export default __webpack_public_path__ + "static/media/transaksi.413f5ab5.svg";